import { Redirect, Route, useLocation } from 'react-router-dom';
import { IonTabs, IonTabBar, IonTabButton, IonLabel, IonRouterOutlet, IonImg } from '@ionic/react';
import Home from '../pages/Home';
import Contact from '../pages/Contact';
import Profile from '../pages/Profile';
import FlightSearch from '../pages/FlightSearch';
import HotelSearch from '../pages/HotelSearch';
import FlightHotelSearch from '../pages/FlightHotelSearch';
import Page from '../pages/Page';
import FlightReservation from '../pages/FlightReservation';
import HotelReservation from '../pages/HotelReservation';
import FlightHotelReservation from '../pages/FlightHotelReservation';
import BlogDetails from '../pages/BlogDetails';
import './Tabs.css';
import homeImg from '../assets/images/tabs-home.svg';
import contactImg from '../assets/images/tabs-contact.svg';
import profileImg from '../assets/images/tabs-profile.svg';

const Tabs = () => {
    const location = useLocation();
    const currentPage = location.pathname;
    var displayTab = "";
    if (
        currentPage === '/search/flight' ||
        currentPage === '/search/hotel' ||
        currentPage === '/search/flightHotel' ||
        currentPage === '/flight/reservation' ||
        currentPage === '/hotel/reservation' ||
        currentPage === '/flightHotel/reservation' ||
        currentPage === '/blog' ||
        currentPage === '/page'
    ) {
        displayTab = 'display-none';
    }
    return (
        <IonTabs className="tabs-container">
            <IonRouterOutlet>
                <Route path="/home" component={Home} />
                <Route path="/profile" component={Profile} />
                <Route path="/contact" component={Contact} />
                <Route path="/search/flight" component={FlightSearch} />
                <Route path="/search/hotel" component={HotelSearch} />
                <Route path="/search/flightHotel" component={FlightHotelSearch} />
                <Route path="/page" component={Page} />
                <Route path="/flight/reservation" component={FlightReservation} />
                <Route path="/hotel/reservation" component={HotelReservation} />
                <Route path="/flightHotel/reservation" component={FlightHotelReservation} />
                <Route path="/blog" component={BlogDetails} />
                <Route path="/" render={() => <Redirect to="/home" />} exact={true} />
            </IonRouterOutlet>
            <IonTabBar slot="bottom" className={displayTab}>
                <IonTabButton tab="contact" href="/contact">
                    <IonImg src={contactImg} className="tabs-icon" />
                    <IonLabel className="tabs-label">ارتباط با ما</IonLabel>
                </IonTabButton>
                <IonTabButton tab="home" href="/home">
                    <IonImg src={homeImg} className="tabs-icon" />
                    <IonLabel className="tabs-label">صفحه اصلی</IonLabel>
                </IonTabButton>
                <IonTabButton tab="profile" href="/profile">
                    <IonImg src={profileImg} className="tabs-icon" />
                    <IonLabel className="tabs-label">حساب کاربری</IonLabel>
                </IonTabButton>
            </IonTabBar>
        </IonTabs>
    );
}

export default Tabs;